<template>
	<div class="ProjectCard">
		<div class="ProjectCard-img">
			<img :src="imgPath" :title="imgTitle" :alt="imgAlt">
		</div>
		<div class="ProjectCard-content">
			<a :href="`${baseUrl}/projects/${id}`">{{ name }}</a>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import CloHeading from '@/base/CloHeading/CloHeading.vue';

export default ({
	name: 'ProjectCard',
	components: {
		CloHeading,
	},
	props: {
		id: {
			type: Number,
			required: true,
		},
		name: {
			type: String,
			required: true,
		},
		imgPath: {
			type: String,
			required: true,
		},
		imgTitle: {
			type: String,
			required: false,
		},
		imgAlt: {
			type: String,
			required: false,
		},
		baseUrl: {
			type: String,
			default: 'https://ebird.org',
		}
	},
	data() {
		return {
		};
	},
	mounted() {
	},
});
</script>

<style lang="scss">
.ProjectCard {
	display: flex;
	align-items: center;
	@include text(3);
	column-gap: $space-rel-sm;
}

.ProjectCard-img {
	flex: 0 0 auto;
	width: 2rem;
	height: 2rem;
	background-color: $color-white;
	border-radius: $space-sm;
	border: 1px solid $color-line;
	overflow: hidden;
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}

.ProjectCard-content {
	flex: 1 1 auto;
	display: flex;
	flex-direction: column;
	row-gap: $space-xs;
	a {
		font-weight: bold;
		@include text(4);
	}
}

.ProjectCard.ProjectCard--responsive {
	@include breakpoint(medium) {
		@include text(4);
		.ProjectCard-img {
			width: 3rem;
			height: 3rem;
		}
		.ProjectCard-content {
			a {
				@include text(5);
			}
		}
	}
}
</style>
